// 开发环境配置项

module.exports = {
    jsonPath: '/',
    serverUrl: 'http://139.224.11.141:9527', // 城投房产
    groupServerUrl: 'http://192.168.2.131:9002', // 集团版接口请求地址
    imgPath: 'http://172.16.70.111:80/images/qad/qad_ct', // 图片资源前缀
};
